import domReady from '@wordpress/dom-ready';

import { initLenis } from './global/lenis.js';
import { setViewportUnits, PlayVideoInViewportOnly, EditableSvg, scrollToHash, initHeaderHeight, initLegalSymbols } from './utils/utilities.js';
import { Offcanvas } from './global/offcanvas';
import { Header } from './global/header';
import { DropdownMenu } from './global/dropdownMenu';
import { OffcanvasNavigation } from './global/offcanvasNavigation.js';
import { Video } from './blocks/video.js';
import { LogoWall } from './blocks/logo-wall.js';
import { Testimonials } from './blocks/testimonials.js';
import { Timeline } from './blocks/timeline.js';
import { Accordion } from './blocks/accordion.js';
import { productFeed } from './blocks/product-feed.js';
import { Stats } from './blocks/stats.js';
import { ProductComponents } from './blocks/single-product-hero.js';
import { TableOfContentsList } from './blocks/list.js';
import { CategoryList } from './blocks/category-list.js';
import { ProductFeaturedImageGallery } from './blocks/product-featured-image-gallery.js';
import { Form } from './blocks/form.js';
import { ScrollAnimation } from './blocks/scroll-animation.js';

domReady(async () => {
    initLenis();

    setViewportUnits();

    scrollToHash();

    Array.from(document.querySelectorAll('.editable-svg')).map((img) => EditableSvg(img));

    // stop autoplay video when out of viewport
    Array.from(document.querySelectorAll('video[autoplay]')).map((video) => PlayVideoInViewportOnly(video));

    Header(document.querySelector('.site-header'));

    DropdownMenu();

    const offcanvas = document.querySelector('.offcanvas');
    if (offcanvas) {
        new Offcanvas(offcanvas);
        OffcanvasNavigation();
    }

    initHeaderHeight();

    // blocks
    Video();
    LogoWall();
    Testimonials();
    Timeline();
    Accordion();
    productFeed();
    Stats();
    ProductComponents();
    TableOfContentsList();
    CategoryList();
    ProductFeaturedImageGallery();
    Form();
    ScrollAnimation();
    initLegalSymbols();
});

import.meta.glob([
    '../../images/**',
    '!../../images/cms/**',
    '../../fonts/**',
]);
